// extracted by mini-css-extract-plugin
export default {"tableHeader":"productCategory_tableHeader__SU0m0"};